exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".review-container[data-v-1617d4ba] {\n  padding: 5px;\n  border: thin solid #999;\n  margin: 5px 0;\n}\n.review-container .review-title[data-v-1617d4ba], .review-container .review-question[data-v-1617d4ba] {\n  font-size: 0.8em;\n  color: #666;\n}", ""]);

// exports
